import { ApplicationConfig, ErrorHandler, importProvidersFrom, LOCALE_ID, inject, provideAppInitializer } from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {LocationStrategy, PathLocationStrategy, registerLocaleData} from "@angular/common";
import {MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {UserRolePermissionsService} from "./common/user-role-permissions.service";
import {AuthInterceptor} from "./auth/auth-interceptor";
import {provideAnimations} from "@angular/platform-browser/animations";
import {provideToastr} from "ngx-toastr";
import {CustomMissingTranslationHandler, HttpLoaderFactory} from "./Main/Administration/Translation/custom-missing-translation-handler.service";
import {LocalizationService} from "./common/localization/localization.service";
import {provideServiceWorker} from '@angular/service-worker';
import {environment} from "../environments/environment";
import {CustomErrorHandler} from "./custom-error-handler";
import {NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule} from 'ngx-google-analytics';

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: ErrorHandler, useClass: CustomErrorHandler },
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
        {
            provide: LOCALE_ID,
            deps: [LocalizationService],
            useFactory: (localizationService: LocalizationService) => localizationService.loadLocaleFromLocalStorage("en-GB", true)!
        },
        provideRouter(routes),
        provideAnimations(),
        provideToastr(),
        provideHttpClient(withInterceptorsFromDi()),
        provideAppInitializer(() => {
        const initializerFn = ((svc: UserRolePermissionsService, localizationService: LocalizationService, translateService: TranslateService) => () => {
                localizationService.loadLocale().then(locale => {
                    registerLocaleData(locale);
                    translateService.use(locale);
                    svc.loadInitialStructure("app config").then(() => {redirectIfUrlContainsHash();});
                });
            })(inject(UserRolePermissionsService), inject(LocalizationService), inject(TranslateService));
        return initializerFn();
      }),
            provideServiceWorker('ncvib-ngsw-worker.js', {
        //provideServiceWorker('ngsw-worker.js', {
            enabled: true,
            registrationStrategy: 'registerWhenStable:120000' // 'registerImmediately'
        }),
        {provide: LocationStrategy, useClass: PathLocationStrategy},
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: CustomMissingTranslationHandler
                }
            }),
            NgxGoogleAnalyticsModule.forRoot(environment.deployed ? 'G-21C4F8V7RL' : ''),
            NgxGoogleAnalyticsRouterModule)
    ]
};

function redirectIfUrlContainsHash() {
    const fullUrl = window.location.href;
    if (fullUrl.includes('#')) {
        window.location.href = fullUrl.replace('#', '');
    }
}
